var _path, _path2, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMoodScrollIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 28,
    viewBox: "0 0 48 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7468 2.10299L0.783274 13.2689C0.359698 13.6643 0.359696 14.3357 0.783272 14.7311L12.7468 25.897C13.4553 26.5583 14.596 25.926 14.4107 24.9747L12.31 14.1912C12.2854 14.0649 12.2854 13.9351 12.31 13.8088L14.4107 3.02526C14.596 2.07398 13.4553 1.44171 12.7468 2.10299Z",
    fill: "white",
    fillOpacity: 0.9
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2443 26.0362L47.1399 14.7526C47.5952 14.3542 47.5952 13.6458 47.1399 13.2474L34.2443 1.96376C33.5224 1.33213 32.4116 1.98065 32.6067 2.91979L34.8668 13.7966C34.8947 13.9308 34.8947 14.0692 34.8668 14.2034L32.6067 25.0802C32.4116 26.0193 33.5224 26.6679 34.2443 26.0362Z",
    fill: "white",
    fillOpacity: 0.9
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23.5,
    cy: 14.5,
    r: 7.5,
    fill: "white",
    fillOpacity: 0.9
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoodScrollIcon);
export default __webpack_public_path__ + "static/media/moodScrollIcon.6586ae1def6b7c399ae567672b09809d.svg";
export { ForwardRef as ReactComponent };